var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-overlay",on:{"click":_vm.closeAlert}},[_c('div',{staticClass:"alert-container",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"alert-title",domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('div',{staticClass:"alert-button",on:{"click":_vm.closeAlert}},[_vm._v("Suivant")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }